import React, { useEffect } from 'react'
import Layout from '../layout/Layout'
import MessagesSvg from '../other/svg/MessagesSvg'
import { useTranslation } from 'react-i18next'
import { FETCH_CONVERSATION, FETCH_CONVERSATIONS, UPDATE_SEEN_BY_DEALER } from 'dealer-reducers'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import { useStringParams } from 'src/hooks/useStringParams'
import BackToConversationList from '../atoms/BackToConversationList'
import View from '../atoms/View'
import MessagesList from '../molecules/MessagesList'
import MessageInput from '../molecules/MessageInput'
import MessageLoader from '../molecules/MessageLoader'

const Conversation = (): JSX.Element => {
  const offer_hash_id = useStringParams('offer_hash_id')
  const { t } = useTranslation()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(FETCH_CONVERSATION({ offer_hash_id }))
    dispatch(FETCH_CONVERSATIONS({}))
  }, [dispatch, offer_hash_id])

  const {
    messages,
    isAdminTyping,
    offer_hash_id: conversationOfferHashId
  } = useSelector((state: RootReducer) => state.conversationReducer)

  useEffect(() => {
    if (conversationOfferHashId !== offer_hash_id) {
      dispatch(UPDATE_SEEN_BY_DEALER({ offer_hash_id }))
    }
  }, [dispatch, offer_hash_id, conversationOfferHashId])

  return (
    <Layout
      withoutToolbar={false}
      iconComponent={<MessagesSvg className="w-8 h-8 text-white" />}
      withFiler={false}
      name={t('messages')}>
      <View className="flex flex-col justify-between w-[600px]">
        <BackToConversationList offer_hash_id={offer_hash_id} />
        <MessagesList messages={messages} />
        <MessageLoader isLoading={isAdminTyping} />
        <MessageInput offerHashId={offer_hash_id} />
      </View>
    </Layout>
  )
}

export default Conversation
